import * as IconLookup from './icons/linearIcons';
import * as SourceIconLookup from './icons/sourceIcons';
export { IconLookup, SourceIconLookup };
// TODO: I'd like to remove this `default`.
export { default as SourceLookup, getSourceIconDataForKey, dataSourceNameMap } from './config/sourceConfig';
export { Icon } from './Icon';
export { SourceIcon } from './SourceIcon';
export { CircleIcon } from './CircleIcon';
